export default __webpack_public_path__ + "/dist/images/followers-inactive.a84e1e32204a61605580afb9f3cf53e6.svg";